import { Card } from '@/components/Card'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { JobProgressionCardContentContainer } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionCardContainers'
import { observer } from 'mobx-react-lite'
import { RoomCardContainer } from '@/features/jobs/details/components/RoomCard/RoomCardContainer'
import { PendingSchedulingContentContainer } from '@/features/jobs/details/components/ConsultationCallCard/ConsultationCallCardContainer'

export interface JobProgressionAndConsultationCardContainerProps {
  vm: JobDetailsViewModel
}

export const JobProgressionAndConsultationCardContainer = observer(
  function JobProgressionAndConsultationCardContainer({
    vm,
  }: JobProgressionAndConsultationCardContainerProps) {
    return (
      <>
        <Card>
          <JobProgressionCardContentContainer vm={vm} />
        </Card>
        {!vm.job.completed &&
          (vm.consultationVm.consultationIsPendingScheduling ? (
            <Card>
              <PendingSchedulingContentContainer vm={vm.consultationVm} />
            </Card>
          ) : (
            <RoomCardContainer
              vm={vm.consultationVm.roomVm}
              titleContent={<>Prepare for the consultation</>}
              descriptionContent={
                <>
                  Schedule a call time with the client before starting the
                  consultation.
                </>
              }
            />
          ))}
      </>
    )
  },
)
